// src/hook.ts
import * as React from "react";
import { isFunction } from "@stepstone-genesis/utilities";
var assignReferences = (ref, value) => {
  if (ref === null) return;
  if (isFunction(ref)) ref(value);
  try {
    ref.current = value;
  } catch (e) {
    console.error(e);
    throw new Error(`Cannot assign ref value of '${value}' to ref '${ref}'`);
  }
};
var useMergedRefs = (theirRef, ourRef) => {
  const mergedRefs = React.useCallback(
    (value) => {
      if (theirRef) assignReferences(theirRef, value);
      if (ourRef) assignReferences(ourRef, value);
    },
    [theirRef, ourRef]
  );
  return mergedRefs;
};
var mergeRefs = (...refs) => {
  return (node) => {
    refs.forEach((ref) => assignReferences(ref, node));
  };
};
export {
  mergeRefs,
  useMergedRefs
};
